
import TestController from '@/controllers/TestController';
import { inject } from 'vue';
import { Options, Vue } from 'vue-property-decorator';
import ErrorPanel from './ErrorPanel.vue';
import LoadingTestPanel from './LoadingTestPanel.vue';
import StartTestPanel from './StartTestPanel.vue';
import TestStartContext from './state/TestStartContext';
import TestStartDisplayType from './state/TestStartDisplayType';

@Options({
  components: { LoadingTestPanel, StartTestPanel, ErrorPanel },
})
export default class TestStartController extends Vue {
  private testController: TestController | undefined = inject<TestController>('testController');
  private context: TestStartContext | undefined;
  private displayType_ = TestStartDisplayType.LOADING;
  private title_ = '';
  startLoading(jwt: string): void {
    this.context = new TestStartContext(this.testController, jwt, this);
    this.context.performFunction();
  }

  private handleStartTest(): void {
    this.$emit('testReady');
  }

  private handleRetry(): void {
    this.context?.setTestBeginState(TestStartContext.LOADING);
    this.context?.performFunction();
  }

  setTitle(value: string) {
    this.title_ = value;
  }

  private getTitle(): string {
    return this.title_ || this.$t('common.wait');
  }

  private get loadingDisplayType(): number {
    return TestStartDisplayType.LOADING;
  }

  private get startDisplayType(): number {
    return TestStartDisplayType.START;
  }

  private get errorDisplayType(): number {
    return TestStartDisplayType.ERROR;
  }

  updateDisplayType(): void {
    if (this.context) {
      this.displayType_ = this.context!.getTestBeginState()!.getView();
    }
  }

  private get displayType(): TestStartDisplayType {
    return this.displayType_;
  }
}
